// extracted by mini-css-extract-plugin
module.exports = {"Shorts":"Shorts_Shorts__aUHv1","values":"Shorts_values__NId_n","chart":"Shorts_chart__HSSSA","currently":"Shorts_currently__Cf7Mm"};